import { useCallback, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

const POPOVER_OPEN_TIMEOUT = 200;
const POPOVER_CLOSE_TIMEOUT = 400;

export const usePopoverLogic = () => {
  const [detailsVisibleForPersona, setDetailsVisibleForPersona] = useState(null);

  const debouncedOpenDetails = useDebouncedCallback((persona) => {
    setDetailsVisibleForPersona(persona);
  }, POPOVER_OPEN_TIMEOUT);

  const debouncedCloseDetails = useDebouncedCallback(() => {
    setDetailsVisibleForPersona(null);
  }, POPOVER_CLOSE_TIMEOUT);

  const handlePersonaMouseEnter = useCallback(
    (persona) => {
      debouncedCloseDetails.cancel();
      debouncedOpenDetails(persona);
    },
    [debouncedCloseDetails, debouncedOpenDetails]
  );

  const handlePersonaMouseLeave = useCallback(() => {
    debouncedOpenDetails.cancel();
    debouncedCloseDetails();
  }, [debouncedOpenDetails, debouncedCloseDetails]);

  const handlePopperMouseEnter = useCallback(() => {
    debouncedCloseDetails.cancel();
  }, [debouncedCloseDetails]);

  const handlePopperMouseLeave = useCallback(() => {
    debouncedCloseDetails();
  }, [debouncedCloseDetails]);

  return {
    detailsVisibleForPersona,
    buttonPersonaProps: {
      onMouseEnter: handlePersonaMouseEnter,
      onMouseLeave: handlePersonaMouseLeave,
    },
    popperProps: {
      onMouseEnter: handlePopperMouseEnter,
      onMouseLeave: handlePopperMouseLeave,
    },
  };
};
